var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("loading-bg " + (_vm.loading ? '' : 'hide') + " " + (_vm.isOpacity ? 'opacity' : ''))},[_c('img',{staticClass:"loading-icon",attrs:{"src":require("@/assets/img/loading_b.gif"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }